import { NgModule } from '@angular/core';
import { CategoryDeleteDialogComponent } from './category-delete-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../../../shared/shared.module';
import { CategoriesService } from '../../../../../services/accounting/categories.service';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
    ],
    declarations: [CategoryDeleteDialogComponent],
    exports: [CategoryDeleteDialogComponent],
    providers: [
        CategoriesService,
    ],
})
export class CategoryDeleteDialogModule
{
}
